export const COMPANY_TYPES = {
	SOLE_TRADER: "SOLE_TRADER",
	NON_GOVERNMENT: "UNDEFINED",
	GOVERNMENT: "GOVERNMENT",
};
